var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-messages.7918ef23.png","uri@2x": __webpack_public_path__ + "icon-messages.3406c1e1.png","uri@3x": __webpack_public_path__ + "icon-messages.e3f69eba.png",
    width: 20,
    height: 20
});